import { useContext, useEffect, useState, useRef } from "react";
import { FaCircle } from "react-icons/fa";
import { DataProvider } from "../../../store/ContextProvider";
import DateRangeFilter from "../../../hooks/dateRange";
import { fetchJobList, DeleteJobs } from "../../../services/fetchJobList";
import KeySearch from "../../../hooks/keySearch";
import Pagination from "../../../hooks/Pagination";
import { FiEye } from "react-icons/fi";
import { FiEdit2 } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import { MdRefresh } from "react-icons/md";


export default function ViewJobs() {
  const { BeURL, showAlert, currentUser } = useContext(DataProvider);

  const searchKey = ["title", "client", "createdByUser.fullName", "skills"]

  const dateRangeRef = useRef(null);

  const [, setAllJobs] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  const [isKey, setIsKey] = useState(false);

  const [rangeFilter, setRangeFilter] = useState({ type: "range", value: "all", key: false });
  const lastQueryRef = useRef("");

  console.log("search tem", searchTerm)

  const setPaginationHandler = (pag = {}) => {
    setCurrentPage(pag.currentPage ?? 1);
    setRowsPerPage(pag.perPage ?? rowsPerPage);
    setTotalPages(pag.totalPages ?? 1);
    setTotal(pag.totalCount ?? 0);
  };

  const handleResetFilters = () => {
    setRangeFilter({ type: "range", value: "all", key: false });
    setSearchTerm("");
    setIsKey(false);
    setCurrentPage(1);
    setRowsPerPage(10);
    // Reset the date range filter component
    dateRangeRef.current?.reset();
  }

  useEffect(() => {
    if (!BeURL || !rangeFilter) return;

    const queryKey = JSON.stringify({
      page: currentPage,
      perPage: rowsPerPage,
      search: searchTerm,
      key: isKey,
      rangeFilter,
    });

    if (lastQueryRef.current === queryKey) return;
    lastQueryRef.current = queryKey;

    fetchJobList({
      BeURL,
      showAlert,
      setJobs,
      setPagination: setPaginationHandler,
      setAllJobs,
      page: currentPage,
      perPage: rowsPerPage,
      search: searchTerm,
      key: isKey,
      rangeFilter
    });
  }, [BeURL, currentPage, rowsPerPage, rangeFilter, searchTerm, isKey]);


  // selection
  const toggleSelect = id => {
    setSelected(s => {
      const copy = new Set(s);
      copy.has(id) ? copy.delete(id) : copy.add(id);
      return copy;
    });
  };

  // searchServer now accepts keyValue from KeySearch
  const searchServer = (term, keyValue = undefined) => {
    setCurrentPage(1);
    fetchJobList({
      BeURL,
      showAlert,
      setJobs,
      setPagination: setPaginationHandler,
      setAllJobs,
      page: 1,
      perPage: rowsPerPage,
      search: term,
      key: typeof keyValue !== "undefined" ? keyValue : isKey,
      rangeFilter
    });
  };

  // delete job
  const onDeleteSingle = (id) => {
    DeleteJobs({ BeURL, showAlert, endpoint: "delete-jobs", ids: [id], message: "Delete job" })
  }

  //Delete jobs
  const onDeleteBulk = (id) => {
    DeleteJobs({ BeURL, showAlert, endpoint: "delete-jobs", ids: Array.from(selected), message: "Delete selected jobs" })
  }


  const onNext = () => currentPage < totalPages && setCurrentPage(p => p + 1);
  const onPrev = () => currentPage > 1 && setCurrentPage(p => p - 1);
  const onRowsChange = (val) => {
    setRowsPerPage(val);
    setCurrentPage(1);
  };


  return (
    <div className="p-4 space-y-4">


      <div className="bg-white border space-y-6 p-5 rounded-xl">
        <div className="flex items-center justify-between gap-3">
          <div className="flex-1 space-y-6">
            <DateRangeFilter
              ref={dateRangeRef}
              onChange={(data) => {
                setRangeFilter(data);
                setCurrentPage(1);
              }}
            />

            <KeySearch
              placeholder="Search Job..."
              searchKeys={searchKey}
              serverSearch={searchServer}
              setSearchTerm={setSearchTerm}
              searchTerm={searchTerm}
              setIsKey={setIsKey}
              isKey={isKey}
            />
          </div>
          <button
            onClick={handleResetFilters}
            title="Reset filters"
            className="h-fit p-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200 flex items-center justify-center"
          >
            <MdRefresh className="text-xl" />
          </button>
        </div>
      </div>

      <div>


        {currentUser.role === 'employer' && (
          <div className="flex flex-wrap justify-between items-center">

            <button
              onClick={() => window.location.href = '/create-job'}
              className="bg-primary-500 text-white md:px-4 md:py-2 md:text-xl text-[10px] px-2 py-1 rounded hover:bg-primary-600"
            >
              Create Job
            </button>

            <button
              onClick={onDeleteBulk}
              className="flex items-center gap-1 text-red-400 text-[10px] px-2 py-1 md:text-xl md:px-3 md:py-1 rounded border border-red-400 hover:text-red-500 hover:border-red-500"
            >
              <FiTrash2 /> Delete Selected
            </button>

          </div>
        )}
      </div>

      <div className="overflow-auto">
        <table className="min-w-full bg-white">
          <thead className="bg-blue-50 text-primary-400">
            <tr>
              {currentUser.role === 'employer' && <th className="p-2">Select</th>}
              <th className=" py-2 text-center ">Client</th>
              <th className=" py-2 text-center ">Title</th>
              <th className=" py-2 text-center ">Openings</th>
              <th className=" py-2 text-center ">Created by</th>
              <th className=" py-2 text-center ">Created At</th>
              <th className=" py-2 text-center ">Updated At</th>
              <th className=" py-2 text-center ">Actions</th>
            </tr>
          </thead>
          <tbody>
            {jobs.length ? jobs.map((job, i) => (
              <tr key={job._id} className={i % 2 ? 'bg-slate-50' : ''}>
                {currentUser.role === 'employer' && (
                  <td className="p-2 text-center">
                    <input
                      type="checkbox"
                      checked={selected.has(job._id)}
                      onChange={() => toggleSelect(job._id)}
                    />
                  </td>
                )}
                {/* <td className="p-2 text-center">{job.id}</td> */}
                <td className="p-2 text-left">
                  <div className="flex items-center gap-2">
                    {job.clientLogo && (
                      <img
                        src={job.clientLogo}
                        alt={job.client || "Client logo"}
                        className="w-8 h-8 object-cover rounded"
                      />
                    )}
                    {job.client || "-"}
                  </div>
                </td>
                <td className="p-2 font-medium text-left ">
                  <div className='flex gap-2 justify-center items-center'>
                    <FaCircle className={`text-[6px] ${job.status === 'live' ? 'text-green-700' : 'text-red-600'}`} />
                    {job.title}
                  </div>
                </td>
                <td className="p-2 text-left">{job.openingsCount || '-'}</td>
                <td className="p-2 text-left">{job.createdByUser?.fullName || '-'}</td>
                <td className="p-2 text-left">{job.createdAt ? (new Date(job.createdAt).toLocaleDateString()) : "-"}</td>
                <td className="p-2 text-left">{job.updatedAt ? (new Date(job.updatedAt).toLocaleDateString()) : "-"}</td>
                <td className="p-2">
                  <div className="flex gap-2 justify-center items-center">
                    <button onClick={() => window.location.href = `/job/${job._id}`}>
                      <FiEye className="text-slate-700 hover:text-slate-800" />
                    </button>
                    {['employer', 'admin'].includes(currentUser.role) && (
                      <button onClick={() => window.location.href = `/update-job/${job._id}`}>
                        <FiEdit2 className="text-slate-700 hover:text-slate-800" />
                      </button>
                    )}
                    {(currentUser.role === 'employer' || currentUser.role === 'admin') && (
                      <button onClick={() => onDeleteSingle(job._id)}>
                        <FiTrash2 className="text-red-700 hover:text-red-800" />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan={currentUser.role === 'employer' ? 6 : 5} className="text-center p-4">
                  No Data available!
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        rowsPerPage={rowsPerPage}
        total={total}
        onPrev={onPrev}
        onNext={onNext}
        onRowsChange={onRowsChange}
      />
    </div>
  );
}
